export default __webpack_public_path__ + "static/media/smartdocs.9395fddc.png";